<footer class="footer-style6">
    <div class="container">
        <div class="logo-box6">
            <a href="/home">
              
             <img src="assets/images/Bessel Footer.png" class="footer-logo" *ngIf="isDarkMode">

            <img src="assets/images/Bessel White Clear.png" class="footer-logo" *ngIf="!isDarkMode">
            </a>
        </div>
        <div class="about-widget6">
            <h5 class="title">Tag along and Stay ahead with
                NexGen Emotion AI-powered Agentic AI.
            </h5>
            <a href="#" target="_blank"
                class="ibt-btn ibt-btn-outline-2">
                <span>Purchase Here</span>
                <i class="icon-arrow-top"></i>
            </a>
            <p><a href="#">© BesselAI Technologies Pvt Ltd 2026.</a> All rights reserved.</p>
        </div>
    </div>
</footer>
<button id="scrollBtn" title="Go to top">
            <i class="fas fa-angle-up"></i>
        </button>